import _ from 'lodash'
import type { IUnfinishedTasks, IViewerHandlers } from '../types'
import { UNFINISHED_TASKS, VIEWER_HANDLERS } from './moduleNames'

const UnfinishedTasks = ({ viewerHandlers }: IViewerHandlers): IUnfinishedTasks => {
	const { unfinishedTasks } = viewerHandlers

	return {
		add: (name) => {
			const id = _.uniqueId()

			unfinishedTasks.add(id, name)

			return () => {
				unfinishedTasks.remove(id)
			}
		},
	}
}

export default {
	factory: UnfinishedTasks,
	deps: [VIEWER_HANDLERS],
	name: UNFINISHED_TASKS,
}
